/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { WarehouseMovementsListResponse } from '../../models/warehouse-movements-list-response';

export interface WarehouseControllerGetMovements$Params {
  related_order_id?: number;
  identifier?: string;
  product_id?: Array<number>;
  created_from_date?: string;
  created_to_date?: string;
  movement_type_id?: number;
  limit: number;
  skip: number;
  order_by?: string;
  order_direction?: string;
}

export function warehouseControllerGetMovements(http: HttpClient, rootUrl: string, params: WarehouseControllerGetMovements$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovementsListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerGetMovements.PATH, 'get');
  if (params) {
    rb.query('related_order_id', params.related_order_id, {});
    rb.query('identifier', params.identifier, {});
    rb.query('product_id', params.product_id, {});
    rb.query('created_from_date', params.created_from_date, {});
    rb.query('created_to_date', params.created_to_date, {});
    rb.query('movement_type_id', params.movement_type_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WarehouseMovementsListResponse;
      }>;
    })
  );
}

warehouseControllerGetMovements.PATH = '/warehouse/movements';
